import classnames from 'classnames';
import { type FunctionComponent } from 'react';

import { isB2B } from '@/core/settings/utils';
import { FreeDeliveryByMMLabel } from '@/core/tamagoshi/FreeDeliveryByMMLabel/FreeDeliveryByMMLabel';
import { FreeDeliveryLabel } from '@/core/tamagoshi/FreeDeliveryLabel/FreeDeliveryLabel';
import { ManoExpressMediumLogo } from '@/core/tamagoshi/Logos/ManoExpressMediumLogo/ManoExpressMediumLogo';
import { LocalizedFreeManoExpressDeliveryLogo } from '@/domains/productDelivery/components/LocalizedFreeManoExpressDeliveryLogo/LocalizedFreeManoExpressDeliveryLogo.default';

import { type ProductCardListingsTranslations } from '../../interfaces';

import styles from './DeliveryLabel.module.scss';

export interface DeliveryLabelProps {
  className?: string;
  deliveryLabel:
    | 'freeDelivery'
    | 'freeDeliveryByMM'
    | 'freeManoExpressDelivery'
    | 'manoExpressDelivery';
  translations: ProductCardListingsTranslations['deliveryLabel'];
}

export const DeliveryLabel: FunctionComponent<DeliveryLabelProps> = ({
  className,
  deliveryLabel,
  translations,
}) => {
  const rootClassNames = classnames(styles.root, className);

  switch (deliveryLabel) {
    case 'freeDelivery':
      return (
        <FreeDeliveryLabel
          label={translations.freeDelivery}
          className={rootClassNames}
          withIcon={false}
        />
      );

    case 'freeDeliveryByMM':
      return (
        <FreeDeliveryByMMLabel
          label={translations.freeDeliveryByMM}
          className={rootClassNames}
          isPro={isB2B()}
        />
      );

    // Mano Express rebranding
    case 'manoExpressDelivery':
      return <ManoExpressMediumLogo className={rootClassNames} />;

    case 'freeManoExpressDelivery':
      return (
        <LocalizedFreeManoExpressDeliveryLogo className={rootClassNames} />
      );
  }
};

DeliveryLabel.displayName = 'DeliveryLabel';
